<div class="flex h-screen flex-col-reverse lg:flex-row relative overflow-hidden">
  <vs-badge
    *ngIf="impersonationBanner.visible"
    theme="primary"
    [config]="{ displayStatusIcon: true, statusIconTheme: 'primary' }"
    class="fixed top-4 right-4 z-[1200] !bg-base !text-primary-700 !border !border-primary-200 !shadow-sm"
  >
    Impersonating: <span class="font-bold">{{ impersonationBanner.customerName }}</span>
  </vs-badge>

  <div
    class="lg:max-w-[420px] lg:min-w-[420px] xl:max-w-[480px] xl:min-w-[480px] 2xl:max-w-[512px] 2xl:min-w-[512px] p-4 lg:p-10 bg-gradient-to-br from-primary-500 to-primary-600 lg:h-auto lg:min-h-[691px] w-full"
    [class]="
      drawerOpen
        ? 'lg:relative absolute bottom-0 z-10 max-h-screen lg:overflow-visible overflow-auto'
        : 'relative h-6 lg:overflow-visible overflow-hidden'
    "
  >
    <div class="flex flex-col justify-between h-full">
      <div>
        <ws-portal-info-card [class.hidden]="!drawerOpen" class="lg:block"></ws-portal-info-card>

        <p class="mx-4 mt-4 text-sm font-medium text-base">
          {{ portalSvc.config.brandName }}'s claim processing is made possible by WarrantySphere<sup>TM</sup>
          <a
            #link
            class="ml-3 cursor-pointer opacity-75 hover:opacity-100"
            cdkOverlayOrigin
            #trigger="cdkOverlayOrigin"
            (click)="open = !overlay.open"
          >
            <span>Learn more</span>
            <svg
              class="inline align-middle ml-1 w-4 h-4 -mt-[2px]"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </a>

          <ng-template
            #overlay="cdkConnectedOverlay"
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="trigger"
            [cdkConnectedOverlayOpen]="open"
            (overlayOutsideClick)="$event.target !== link ? (open = false) : ''"
          >
            <div
              class="mt-1 z-10 overflow-hidden max-w-[320px] bg-base rounded divide-y divide-gray-200 text-gray-900 shadow text-sm font-medium"
            >
              <a
                class="flex items-center py-2 px-4 w-full hover:bg-gray-100 hover:text-primary-600"
                routerLink="/privacy"
                target="_blank"
              >
                <svg
                  class="mr-2 w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                  ></path>
                </svg>
                <span>Privacy Policy</span>
              </a>
              <a
                class="flex items-center py-2 px-4 w-full hover:bg-gray-100 hover:text-primary-600"
                routerLink="/terms-of-service"
                target="_blank"
              >
                <svg
                  class="mr-2 w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  ></path>
                </svg>
                <span>Terms of Use</span>
              </a>
            </div>
          </ng-template>
        </p>

        <div *ngIf="isSignedIn$ | async" class="grid my-5 gap-4 w-full">
          <ng-container *ngIf="(hasWarranties$ | async) || (hasPayments$ | async)">
            <vs-divider class="!bg-[#f8fafc] !opacity-50 z-50"></vs-divider>
            <button
              *ngIf="hasWarranties$ | async"
              routerLink="/warranty"
              vs-button
              appearance="clear"
              [class]="
                checkLink('warranty')
                  ? '!transition duration-700 !h-8 !w-full !text-base-white !bg-primary-400 !justify-start !font-semibold hover:!bg-base-white hover:!text-primary-400 z-50'
                  : '!transition duration-700 !h-8 !w-full !text-primary-200 !justify-start hover:!bg-base-white !font-semibold group z-50'
              "
            >
              <vs-icon class="ml-3" name="folder-shield"></vs-icon>
              <p class="group-hover:!text-base-black">My coverage</p>
            </button>
            <button
              *ngIf="hasPayments$ | async"
              routerLink="/finances"
              vs-button
              appearance="clear"
              [class]="
                checkLink('finances')
                  ? '!transition duration-700 !h-8 !w-full !text-base-white !bg-primary-400 !justify-start !font-semibold hover:!bg-base-white hover:!text-primary-400 z-50'
                  : '!transition duration-700 !h-8 !w-full !text-primary-200 !justify-start  !font-semibold hover:!bg-base-white group z-50'
              "
            >
              <vs-icon class="ml-3" name="credit-card-shield"></vs-icon>
              <p class="group-hover:!text-base-black">Billing history</p>
            </button>
          </ng-container>
          <button
            routerLink="/checkout"
            vs-button
            class="!w-full !h-[44px] !text-primary-700 !bg-primary-50 !border-primary-50 !font-semibold z-50"
            *ngIf="!checkLink('checkout') && (policiesAvailable$ | async) && !salesDisabled"
          >
            <vs-icon name="folder-plus"></vs-icon> New coverage
          </button>
          <vs-divider class="!bg-[#f8fafc] !opacity-50 z-50"></vs-divider>
        </div>
        <vs-sign-out-button (signedOut)="signedOut()"></vs-sign-out-button>
      </div>

      <div [innerHTML]="portalSvc.config.promoText" class="mx-4 mt-4 text-sm font-medium text-base"></div>

      <div
        class="hidden lg:block lg:translate-x-14 xl:translate-x-16 2xl:translate-x-20 2xl:scale-105 origin-right translate-y-16 2xl:translate-y-14"
      ></div>
    </div>

    <button
      (click)="drawerOpen = !drawerOpen"
      type="button"
      [class.top-6]="drawerOpen"
      [class.top-1]="!drawerOpen"
      [class.right-6]="drawerOpen"
      [class.right-2]="!drawerOpen"
      [class.text-base-dark]="drawerOpen"
      [class.text-base]="!drawerOpen"
      class="lg:hidden absolute hover:bg-primary-200 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-full text-sm p-1 text-center inline-flex items-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
    >
      <svg
        *ngIf="drawerOpen; else notOpen"
        xmlns="http://www.w3.org/2000/svg"
        class="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>

      <ng-template #notOpen>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </ng-template>
    </button>
  </div>

  <div cdkScrollable class="flex-grow px-4 py-3 lg:px-14 lg:py-10 bg-gray-50 overflow-auto scrollbar-thin">
    <router-outlet></router-outlet>
  </div>

  <div class="h-1 bg-gradient-to-r from-primary-400 to-primary-600"></div>
</div>
